export const GAME = {
  WIDTH: 1024,
  HEIGHT: 768,
  BG_COLOR: '#1a1a2e',
} as const;

export const BALANCE = {
  STARTING_HP: 50,
  STARTING_DECK: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  HAND_SIZE: 5,
  MAX_DECK_SIZE: 20,
  MAX_CARD_NUMBER: 10,
  MIN_CARD_NUMBER: -10,
} as const;

export const CARD = {
  WIDTH: 80,
  HEIGHT: 120,
  BORDER_RADIUS: 8,
  FONT_SIZE: 32,
  FONT_SIZE_PIXEL: 20,
  COLORS: {
    hand: 0x2d2d44,
    attack: 0xc62828,
    defense: 0x1565c0,
    ability: 0x2e7d32,
    border: 0x666680,
    hover: 0xffd700,
    text: '#ffffff',
    number: '#ffffff',
  },
} as const;

export const ZONES = {
  ATTACK: { x: 200, y: 325, label: 'ATTACK', color: 0xc62828 },
  DEFENSE: { x: 512, y: 325, label: 'DEFENSE', color: 0x1565c0 },
  ABILITY: { x: 824, y: 325, label: 'ABILITY', color: 0x2e7d32 },
  WIDTH: 200,
  HEIGHT: 200,
} as const;

export const HAND = {
  Y: 640,
  SPACING: 100,
} as const;

export const ENEMY = {
  X: 512,
  Y: 140,
  HP_BAR_WIDTH: 200,
  HP_BAR_HEIGHT: 16,
} as const;

export const UI = {
  PLAYER_HP_X: 56,
  PLAYER_HP_Y: 714,
  HP_BAR_WIDTH: 200,
  HP_BAR_HEIGHT: 20,
  DECK_COUNT_X: 970,
  DECK_COUNT_Y: 714,
  END_TURN_X: 512,
  END_TURN_Y: 548,
} as const;

export const ANIM = {
  CARD_DEAL_DURATION: 200,
  CARD_PLAY_DURATION: 300,
  DAMAGE_FLASH_DURATION: 150,
  SHAKE_DURATION: 100,
  SHAKE_INTENSITY: 5,
} as const;
